import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { Reveal, MaskLines, HoverZoomImage } from "../components/motion/Reveal.jsx";
import useSeo from "../hooks/useSeo.js";
import CTABanner from "../components/ui/CTABanner.jsx";
import { BLOG_POSTS } from "../blogs.js";

export default function Blog() {
  useSeo({
    title: "The Oneiros Journal — Fitness, Sports & Family Wellness Blog | Oneiros Sports Club Surat",
    description:
      "Training guides, nutrition, kids' sports, recovery and club life from Oneiros Sports Club Surat — written for the Katargam, Adajan and Varachha community.",
    image: "/oneiros/kat-gym.jpg",
  });

  return (
    <>
      <section className="mx-auto max-w-[1440px] px-6 pb-16 pt-36 lg:px-12 lg:pt-48">
        <Reveal>
          <p className="eyebrow">The Oneiros Journal</p>
        </Reveal>
        <MaskLines
          lines={["Stories for the", "Stronger Version", "of Your Family."]}
          className="mt-5 font-display text-4xl leading-[1.05] sm:text-5xl lg:text-6xl"
        />
        <Reveal delay={0.2}>
          <p className="mt-6 max-w-2xl text-base leading-relaxed text-mute md:text-lg">
            Training wisdom, nutrition, kids' sports and club life — written for every member of the Oneiros family, from first-timers to athletes.
          </p>
        </Reveal>
      </section>

      <section className="mx-auto max-w-[1440px] px-6 pb-24 lg:px-12 lg:pb-32">
        <div className="grid gap-8 md:grid-cols-2 lg:grid-cols-3" data-testid="blog-listing">
          {BLOG_POSTS.map((post, i) => (
            <Reveal key={post.slug} delay={(i % 3) * 0.07} className="h-full">
              <Link
                to={`/blog/${post.slug}`}
                data-testid={`blog-card-${post.slug}`}
                className="group flex h-full flex-col overflow-hidden rounded-lg border border-hairline bg-white transition-shadow duration-300 hover:shadow-[0_30px_60px_-30px_rgba(11,25,44,0.35)]"
              >
                <HoverZoomImage src={post.image} alt={post.title} className="aspect-[4/3] w-full" />
                <div className="flex flex-1 flex-col p-6">
                  <div className="flex items-center gap-3 text-[10px] font-bold uppercase tracking-[0.2em]">
                    <span className="text-brand">{post.category}</span>
                    <span className="text-mute/60">{post.readTime}</span>
                  </div>
                  <h2 className="mt-3 font-display text-xl leading-snug text-navy transition-colors duration-300 group-hover:text-brand">{post.title}</h2>
                  <p className="mt-3 text-sm leading-relaxed text-mute">{post.excerpt}</p>
                  <span className="mt-auto inline-flex items-center gap-2 pt-5 text-[10px] font-bold uppercase tracking-[0.22em] text-navy transition-colors group-hover:text-brand">
                    Read Article <ArrowUpRight className="h-3.5 w-3.5" />
                  </span>
                </div>
              </Link>
            </Reveal>
          ))}
        </div>
      </section>

      <CTABanner
        eyebrow="Keep Reading"
        lines={["More Stories", "Every Week."]}
        primary={{ label: "Enquire Now", to: "/contact" }}
        secondary={{ label: "Explore the Clubs", to: "/our-clubs" }}
        testId="blog-final-cta"
      />
    </>
  );
}
